/*
 * @Author: 杨道博
 * @Date: 2022-08-01 11:05:11
 * @LastEditors: 梅豆
 * @LastEditTime: 2023-04-21 10:21:41
 * @Description: store文件
 * @FilePath: \spm-fe-trunkd:\zdys\防汛抗旱应急支持系统\ys.fxkh_yzt\src\store\index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user';
import urlConfig from './modules/urlConfig';

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user,
    urlConfig
  }
})